import { render, staticRenderFns } from "./footankle.vue?vue&type=template&id=26024472&scoped=true&"
import script from "./footankle.vue?vue&type=script&lang=js&"
export * from "./footankle.vue?vue&type=script&lang=js&"
import style0 from "./footankle.vue?vue&type=style&index=0&id=26024472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26024472",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26024472')) {
      api.createRecord('26024472', component.options)
    } else {
      api.reload('26024472', component.options)
    }
    module.hot.accept("./footankle.vue?vue&type=template&id=26024472&scoped=true&", function () {
      api.rerender('26024472', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/traning/footankle.vue"
export default component.exports